export function areValuesDifferentIgnoringCase(value, comparisonValue) {
  const normalizedValue = typeof value === 'string' ? value.toUpperCase() : value;
  const normalizedComparisonValue = typeof comparisonValue === 'string'
    ? comparisonValue.toUpperCase()
    : comparisonValue;

  return normalizedValue !== normalizedComparisonValue;
}

export function isMobile() {
  const isMobileUA = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
  const isSmallViewport = window.matchMedia('(max-width: 768px)').matches;
  return isMobileUA && isSmallViewport;
}
